module.exports = __webpack_public_path__ + "static/media/section1.85952f04.jpg";